import type { Breakpoint } from '@noths/polaris-client-ribbons-base';
import { getContentstackImageURL } from '@noths/polaris-client-utils';
import type { ImageAspectRatio } from '@noths/polaris-dev-ts-types';

import type { AspectRatioSizeSetType, ContentTilesImage } from './types';
import type { ImageSrcGetterType } from 'client-ribbons-design-system/types/imageSrcSets';

export const getImgSourcesByBreakpoint = (
  imageSrcGetter: ImageSrcGetterType,
  aspectRatioSizeSet: AspectRatioSizeSetType[],
) =>
  aspectRatioSizeSet.reduce((sources, set) => {
    sources[set.breakpoint as Breakpoint] = set.imgs.map((image) =>
      imageSrcGetter({
        width: image.width,
        aspectRatio: image.aspectRatio as ImageAspectRatio,
      }),
    );

    return sources;
  }, {});

export const generateImgSrcSet = (imgArray: string[]) =>
  imgArray.reduce((srcSet, image, i, arr) => {
    const conjunction = arr.length > 1 ? (i === 0 ? ' 1x,' : ' 2x') : '';
    return (srcSet += image + conjunction);
  }, '');

export const contentStackImageSrcGetter =
  (originalURL: string) =>
  ({ aspectRatio, width }: ContentTilesImage) =>
    getContentstackImageURL(originalURL, width, { aspectRatio });
